import { createTheme } from '@mui/material'

export const theme = createTheme({
    palette: {
        primary: {
            main: '#F18A00',
            contrastText: '#fff',
        },
        secondary: {
            light: '#ECF0F1',
            main: '#212121',
            contrastText: '#fff',
        },
        error: {
            main: '#B2301E',
        },
        warning: {
            main: '#F4BE33',
        },
        info: {
            main: '#339AD4',
        },
        success: {
            main: '#33AA94',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontWeight: 550,
                },
                outlined: ({ theme, ownerState }) =>
                    ownerState.color === 'secondary' && {
                        backgroundColor: theme.palette.secondary.light,
                        border: 'none',
                        '&:hover': {
                            border: 'none',
                            backgroundColor: theme.palette.secondary.main,
                            color: theme.palette.secondary.contrastText,
                        },
                    },
            },
        },
    },
})

export type Theme = typeof theme
